import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import locale from "csi/locale";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const SourceTypeRenderer = declare(Renderer, {
	/**
	 * @override
	 * Render source type for linked Size Charts
	 */
	toHtmlStatic(ctx, h, refNode, actionData) {
		if (ctx.getNodeType() === "SizeChart" && xml.isValidURL(ctx.getNode()?.ShapeSizeChart)) {
			html.text(refNode, locale.type("Shape") + " " + locale.type("SizeChart"));
		}
		return true;
	},
});

export = SourceTypeRenderer;
